import { shape, object } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import compose from 'recompose/compose'
import lifecycle from 'recompose/lifecycle'
import withProps from 'recompose/withProps'

import CellView from './Cell'

const Cell = compose(
  lifecycle({
    shouldComponentUpdate (nextProps) {
      if (nextProps.color !== this.props.color) return true
      if (nextProps.isFromCell !== this.props.isFromCell) return true
      if (nextProps.scope !== this.props.scope) return true
      return false
    },
  }),

  scope(
    consumeProps({
      using: shape({
        fromCell: object,
      }).isRequired,
    }),

    withProps(({ using: { fromCell } }) => ({
      fromCell,
    })),

    exposeProps([
      'fromCell',
    ]),
  )
)(CellView)

Cell.displayName = 'Cell'

export default Cell



// WEBPACK FOOTER //
// ./src/components/RangeEditor/Grid/Row/Cell/index.js